/**
 * Method through which a user signed up.
 */
export enum AccountType {
  email = 'email',
  phone = 'phone',
  messenger = 'messenger',
  social = 'social'
}
